import { render } from "./DrinksBody.vue?vue&type=template&id=6b0e84ac&scoped=true"
import script from "./DrinksBody.vue?vue&type=script&lang=js"
export * from "./DrinksBody.vue?vue&type=script&lang=js"

import "./DrinksBody.vue?vue&type=style&index=0&id=6b0e84ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0e84ac"]])

export default __exports__